export { internalPromoIds } from './lib/InternalPromoCard/internalPromoData';
export { default as FeaturedProperties } from './lib';
